import { get, post, postV2, delete_request } from '../tools/http';
import {getDefaultFilters} from "@/components/user-search/filters";
import {isEmpty} from "@/tools/filters";
import Vue from 'vue';

export default {
    state: {
        userSearchProjects: [],
        userSearchData: {},
        allProjectsList: [],
        rootProjectsList: [],
        userSearchFilters: getDefaultFilters(),
        userMainSearchString: "",
        usersQueryData: "",
        usersQueryFilter: { params: getDefaultFilters(), searchString: '', options: {}, tags: [] },
    },
    mutations: {
        setUserSearchProjects: (state, items) => {
            state.userSearchProjects = items || [];
        },
        addUserSearchData: (state, items) => {
            state.userSearchData = {
                ...state.userSearchData,
                ...Object.fromEntries(
                    items.map(v => [v.userId, v])
                ),
            };
        },
        setUserMainSearchString: (state, string) => {
          state.userMainSearchString = string;
        },
        addUsersQueryData: (state, data) => {
            state.usersQueryData = data;
        },
        addUsersQueryFilter: (state, data) => {
            state.usersQueryFilter = data;
        },
        setAllProjectsList(state, items) {
            state.allProjectsList = items.map((item) => {
              item.name = `${item.name} (${new Date(item.dateStart).toLocaleString('ru-RU').split(',')[0]}-${new Date(item.dateEnd).toLocaleString('ru-RU').split(',')[0]})`;
              return item;
            });
        },
        setRootProjectsList(state, items) {
            state.rootProjectsList = items;
        },
        setUserSearchFilters: (state, payload) => {
          if(payload.mode === 'default') {
            state.userSearchFilters = getDefaultFilters();
          } else if (payload.mode === 'setWithType') {
            Vue.set(state.userSearchFilters[payload.type], payload.key, payload.filter);
          } else if (payload.mode === 'setWithoutType') {
              Vue.set(state.userSearchFilters, payload.key, payload.filter);
          } else if (payload.mode === 'setDefinite') {
              const keys = payload.key.split('.');
              state.userSearchFilters[keys[0]][keys[1]] = payload.value;
          }
          
        },
    },
    actions: {
        async addToFavorite(ctx, userId) {
          const payload = await postV2('profile', `friend/${userId}`, null, true, { full: true, nullOnError: false });
          return payload.status === 'success';
        },
        async deleteFromFavorite(ctx, userId) {
          const payload = await delete_request('profile', `friend/${userId}`, null, true);
          return payload.status === 'success';
        },
        async userSearchLoadProjects(ctx) {
            const payload = await get('projects2', 'api/v1/projectlite', {}, true);

            ctx.commit('setUserSearchProjects', payload.data ? payload.data : []);

            return payload.data;
        },

        async loadUsersData(ctx, userIds) {
            const payload = await post('profile', `users/filter?only_ids=1`, {
                'fields': ['userId', 'avatar', 'avatarOfficial', 'deletedAt', 'dateOfBirth'],
                'filters': [
                    {
                        'name': 'userIds',
                        'value': userIds,
                    },
                ],
            }, true);

            ctx.commit('addUserSearchData', (payload && payload.users) || []);

            return payload;
        },

        async loadAllProjectsList(ctx) {
            const payload = await get('projects2', 'api/v1/allprojectlite', {}, true);

            ctx.commit('setAllProjectsList', payload.data ? payload.data : []);

            return payload.data;
        },

        async fetchAllProjectsList(ctx, filter = {
            type: null,
            projectGroupId: null,
        }) {
            const query = [];
            filter = filter || {};

            for (const field in filter) {
                const v = filter[field];

                if (!isEmpty(v)) {
                    if (v instanceof Array) {
                        v.forEach(vv => {
                            query.push(`filter[${field}]=${encodeURIComponent(vv)}`);
                        });
                    } else {
                        query.push(`filter[${field}]=${encodeURIComponent(v)}`);
                    }
                }
            }

            const payload = await get('projects2', `api/v1/allprojectlite?${query.join('&')}`, {}, true);

            return payload.data;
        },

        async loadRootProjectsList(ctx) {
            const payload = await get('projects2', 'api/v1/projectgroup', {}, true);

            ctx.commit('setRootProjectsList', payload.data ? payload.data : []);

            return payload.data;
        },

        loadUsersQueryData(ctx, data) {
            ctx.commit('addUsersQueryData', data);
        },
        async loadProjects2NamesByIds(ctx, data) {
          const payload = await postV2('projects2', `api/v1/project/names`, data, true, { full: true, nullOnError: false });
          return payload;
        },
        async loadProjectsNamesByIds(ctx, data) {
          const payload = await postV2('projects', `dict/admin/projects`, {filter: {
            id: data,
          }}, true, { full: true, nullOnError: false });
          return payload.data;
        },
        async loadNominations2NamesByIds(ctx, data) {
          const payload = await postV2('projects2', `api/v1/nomination/names`, data, true, { full: true, nullOnError: false });
          return payload;
        },
        async loadNominationsNamesByIds(ctx, data) {
          const payload = await postV2('projects', `dict/admin/nominations`, {filter: {
            id: data,
          }}, true, { full: true, nullOnError: false });
          return payload.data;
        },
        setUsersQueryFilter(ctx, data) {
          ctx.commit('addUsersQueryFilter', data);
        },
    },
    getters: {
        getUserSearchProjects: (state) => state.userSearchProjects,
        getUserSearchData: state => state.userSearchData,
        getAllProjectsList: state => state.allProjectsList,
        getRootProjectsList: state => state.rootProjectsList,
        getUserSearchFilters: state => { 
          return state.userSearchFilters;
        },
        getUserMainSearchString: state => state.userMainSearchString,
        getUsersQueryData: state => state.usersQueryData,
        getUsersQueryFilter: state => state.usersQueryFilter,
    },
};
